import { render, staticRenderFns } from "./c_title.vue?vue&type=template&id=28c7d3b3&scoped=true"
import script from "./c_title.vue?vue&type=script&lang=js"
export * from "./c_title.vue?vue&type=script&lang=js"
import style0 from "./c_title.vue?vue&type=style&index=0&id=28c7d3b3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7d3b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c7d3b3')) {
      api.createRecord('28c7d3b3', component.options)
    } else {
      api.reload('28c7d3b3', component.options)
    }
    module.hot.accept("./c_title.vue?vue&type=template&id=28c7d3b3&scoped=true", function () {
      api.rerender('28c7d3b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_title.vue"
export default component.exports